import { useEffect } from "react";

import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Solar_Power from "./solar-power/Solar_Power";
import Our_Presence from "./our-presence/Our_Presence";
import Free_Consultation from "./free-consultation/Free_Consultation";
import Why_Choose_Us from "../about-us/why_choose_us/Why_Choose_Us";
import Trusted_Communities from "./trusted-communities/Trusted_Communities";
import What_Customer_Say from "./what-customer-say/What_Customer_Say";
import Get_enquiry from "./get_enquiry/Get_enquiry";
import Tech_Insights from "./tech_Insights/Tech_Insights";
import StatsSection from "./statsSection/StatsSection";

function Home() {


  return (
    <>
     
      <div >
        <Banner />
      </div>

      
      <div >
        <Solar_Power />
      </div>

     
      <div >
        <Get_enquiry />
      </div>

      
      <div >
        <Our_Presence />
      </div>

       <div >
        {/* <StatsSection /> */}
      </div>

      
      <div >
        {/* <Free_Consultation /> */}
      </div>

      {/* In Up */}
      <div >
        <Tech_Insights />
      </div>

      {/* Up Flip */}
      <div >
        <Why_Choose_Us />
      </div>

     
      <div >
        {/* <Trusted_Communities /> */}
      </div>

      {/* Bottom Flip */}
      <div >
        {/* <What_Customer_Say /> */}
      </div>
    </>
  );
}

export default Home;